export enum FILTER_FORM_CONTROLS {
  TEXT = 'text',
  FROM = 'from',
  TO = 'to',
  TYPE = 'type',
  TYPE_ID = 'typeId',
}
